var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dv-border-box-12',{staticClass:"relative"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('pondSummary')))]),_c('e-chart',{attrs:{"options":_vm.options,"id":"box","height":"350px","width":"100%"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }